import $ from 'jquery'

async function init () {
  $('.tiles-slider').each(async function () {
    await import(/* webpackChunkName: "slick" */ 'slick-carousel/slick/slick')
    initSlider(this)
  })
}

function initSlider (element) {
  let $element = $(element),
    sliderNav = $element.parents('.tiles-module').find('.dot')

  $element.slick({
    lazyLoad: 'ondemand',
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    responsive: [{
      breakpoint: 992,
      settings: {
        centerPadding: '30vw',
      }
    }, {
      breakpoint: 768,
      settings: {
        centerPadding: '22vw',
      }
    }, {
      breakpoint: 450,
      settings: {
        centerPadding: '20vw',
      }
    }, {
      breakpoint: 320,
      settings: {
        centerPadding: '15vw',
      }
    }]
  })

  $element.on('lazyLoaded', function (evt, slick, $img) {
    if ($img.attr('data-srcset') !== undefined) {
      $img.attr('srcset', $img.attr('data-srcset'))
      $img.removeAttr('data-srcset')
    }
    $img.attr('src', $img.attr('data-src'))
    $img.removeAttr('data-src')
  })

  $element.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    const slideCount = slick.slideCount
    if (nextSlide == 0) {
      $(this).find('[data-slick-index=' + slideCount + ']').addClass('next-active')
    } else {
      $(this).find('[data-slick-index=' + slideCount + ']').removeClass('next-active')
    }
  })

  if (sliderNav.length != 0) {
    indicator($element, sliderNav)
  }

  $(window).one('accordion-finished', function () {
    $element.parents('.collapse').one('shown.bs.collapse', function () {
      $element.slick('setPosition')
    })
  })
  // element.parent("collapse").on("resizeend", function() {
  //     $element.slick('setPosition');
  // });
}

function indicator (slider, sliderNav) {
  sliderNav.each(function () {
    $(this).on('click', function () {
      let id = $(this).data('slider-indicator')
      slider.slick('slickGoTo', id, !true)
    })
  })

  slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    sliderNav.each(function () {
      $(this).removeClass('active')
      if ($(this).data('slider-indicator') === nextSlide) {
        $(this).addClass('active')
      }
    })
  })
}

export default {
  init
}
